<template>
  <b-alert :show="true" :variant="votingRulesPass ? 'info' : 'danger'">
    <h2 class="mb-3"><strong>Informations</strong></h2>

    <b-row>
      <b-col>
        <h3 class="mb-3"><strong>Majorité</strong></h3>

        <div>
          Total tantiemes generales :
          <strong>{{ votingLimitRules.totalTantiemesGenerales }}</strong>
        </div>

        <div v-if="votingLimitRules.plafonMajorityIsActive" class="my-3">
          <div><strong>Plafond de majorité est active</strong></div>
          <div>
            Tantièmes plafon :
            <strong>{{ votingLimitRules.plafonMajorityTantiemes }}</strong> &nbsp;
            <em>(le nombre de tantiemes calculé en pourcentage)</em>
          </div>
          <div>
            Total reduit tantièmes générales :
            <strong>{{ votingLimitRules.totalTantiemesGeneralesPlafonMajority }}</strong>
          </div>
        </div>

        <div v-else-if="votingLimitRules.article22IsActive" class="my-3">
          <div><strong>L'article 22 est active</strong></div>
          <div v-if="votingLimitRules.buildingOwnerIdArticle22">
            Total reduit tantièmes générales :
            <strong>{{ votingLimitRules.totalTantiemesGeneralesArticle22 }}</strong>
          </div>
          <div v-else>
            <div>Aucune réduction ...</div>
          </div>
        </div>
      </b-col>

      <b-col class="border-left" :class="votingRulesPass ? 'border-info' : 'border-danger'">
        <h3 class="mb-3"><strong>Pouvoirs</strong></h3>

        <div v-if="votingLimitRules.votingLimitIsActive">
          <div><strong>Les restrictions sont actives</strong></div>
          <div>
            <span v-if="votingLimitRules.votingLimitOperator == rulesOptions.rulesOperators.et">
              Les deux limites doivent être respectées <strong>[et]</strong>
            </span>
            <span v-else> Au moins une des limites doit être respectée <strong>[ou]</strong> </span>
          </div>
          <ul>
            <li>
              Limite de mandats par participant:
              <strong>{{ votingLimitRules.votesLimitPerMandate }}</strong>
            </li>
            <li>
              Limite tantièmes par participant:
              <strong>
                {{ votingLimitRules.tantiemesLimitPerMandate }} [{{
                  votingLimitRules.votingIncludesMandate == true
                    ? "mandataire inclus"
                    : "mandataire non inclus"
                }}]
              </strong>
              &nbsp;
              <em>(le nombre de tantiemes calculé en pourcentage)</em>
            </li>
          </ul>
        </div>
        <div v-else>
          <div>Aucune restriction ...</div>
        </div>
      </b-col>
    </b-row>
    <b-row class="border-top mt-2" :class="votingRulesPass ? 'border-info' : 'border-danger'">
      <b-col cols="6">
        <h3 class="mb-3 mt-3"><strong>Taux de Présence</strong></h3>
        <div>
          Par rapport au nombre de participants :
          <strong>{{ totalPercentPresence }} %</strong>
          <div
            v-b-tooltip.hover
            class="btn"
            title="Selon le nombre de participants présents, représentés ou ayant voté par correspondance"
          >
            <font-awesome-icon icon="info-circle" size="1x" />
          </div>
        </div>
        <div
          v-if="totalTantiemesChargeGeneral && totalPresentOrRepresentedTantiemesChargeGeneral"
          class="mb-3"
        >
          Par rapport aux tantièmes :
          <strong
            >{{
              calculateTotalPresentOrRepresentedTantiemes(
                totalTantiemesChargeGeneral,
                totalPresentOrRepresentedTantiemesChargeGeneral
              )
            }}
            %</strong
          >
        </div>

        <b-progress
          v-if="totalTantiemesChargeGeneral"
          show-value
          :max="totalTantiemesChargeGeneral"
        >
          <b-progress-bar
            show-value
            :value="totalPresentOrRepresentedTantiemesChargeGeneral"
            :label="`${totalPresentOrRepresentedTantiemesChargeGeneral} / ${totalTantiemesChargeGeneral} tantièmes`"
          />
        </b-progress>
      </b-col>
    </b-row>
  </b-alert>
</template>

<script>
export default {
  props: {
    votingRulesPass: {
      type: Boolean,
      default: false,
    },
    totalPercentPresence: {
      type: Number,
      default: 0,
    },
    totalTantiemesChargeGeneral: {
      type: Number,
      default: 0,
    },
    totalPresentOrRepresentedTantiemesChargeGeneral: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    calculateTotalPresentOrRepresentedTantiemes(
      totalTantiemesChargeGeneral,
      totalPresentOrRepresentedTantiemesChargeGeneral
    ) {
      return (
        (totalPresentOrRepresentedTantiemesChargeGeneral * 100) /
        totalTantiemesChargeGeneral
      ).toFixed(2);
    },
  },
};
</script>
